import React from 'react'
import { DeedTypography } from '../Atoms'

const findFirstHighlight = (highlight) => {
  const firstHighlight = highlight.findIndex(line => line.includes('<strong>'))
  if (firstHighlight === -1) return 0
  return firstHighlight
}

const TextHighlight = ({ text, highlighted_text, maxLines = null }) => {
  let limitedText = text
  if (highlighted_text) limitedText = highlighted_text
  const firstHighlightIndex = findFirstHighlight(limitedText)
  let frontLinesCutOff = false
  let backLinesCutOff = false
  if (maxLines) {
    const firstLineOffset = 2
    const firstLine = Math.max(firstHighlightIndex - firstLineOffset, 0)
    frontLinesCutOff = firstLine !== 0
    const lastLine = Math.min(firstLine + maxLines, limitedText.length)
    backLinesCutOff = lastLine !== limitedText.length
    limitedText = limitedText.slice(firstLine, lastLine)
  }
  let highlightedText = limitedText.join(' ')

  if (frontLinesCutOff) highlightedText = "... " + highlightedText
  if (backLinesCutOff) highlightedText = highlightedText + " ..."

  return (
    <DeedTypography dangerouslySetInnerHTML={{ __html: highlightedText }} />
  )
}

export default TextHighlight
